import { render, staticRenderFns } from "./RecommendationBusiness.vue?vue&type=template&id=1ebba96a&"
import script from "./RecommendationBusiness.vue?vue&type=script&lang=js&"
export * from "./RecommendationBusiness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports